"use client";

import { useQuery } from "@tanstack/react-query";
import {
  getAdminDashboardStatisticsAction,
  getAdminDashboardStakeSummaryAction,
  getAdminDashboardFinancialSummaryAction,
  getAdminDashboardRecentValidatorAction,
  getAdminDashboardUnbondingRequestAction,
  getAdminDashboardOverviewAction,
} from "@/resources/actions/admin.actions";
import { queryKeys } from "@/lib/query-keys";

export function useAdminDashboard() {
  const statisticsQuery = useQuery({
    queryKey: queryKeys.admin.dashboard.statistics(),
    queryFn: async () => {
      const result = await getAdminDashboardStatisticsAction();
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    staleTime: 500, // 500ms
  });

  const stakeSummaryQuery = useQuery({
    queryKey: queryKeys.admin.dashboard.stakeSummary(),
    queryFn: async () => {
      const result = await getAdminDashboardStakeSummaryAction();
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    staleTime: 500, // 500ms
  });

  const financialSummaryQuery = useQuery({
    queryKey: queryKeys.admin.dashboard.financialSummary(),
    queryFn: async () => {
      const result = await getAdminDashboardFinancialSummaryAction();
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    staleTime: 500, // 500ms
  });

  const recentValidatorQuery = useQuery({
    queryKey: queryKeys.admin.dashboard.recentValidator(),
    queryFn: async () => {
      const result = await getAdminDashboardRecentValidatorAction();
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    staleTime: 500, // 500ms
  });

  const unbondingRequestQuery = useQuery({
    queryKey: queryKeys.admin.dashboard.unbondingRequest(),
    queryFn: async () => {
      const result = await getAdminDashboardUnbondingRequestAction();
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    staleTime: 500, // 500ms
  });

  const overviewQuery = useQuery({
    queryKey: queryKeys.admin.dashboard.overview(),
    queryFn: async () => {
      const result = await getAdminDashboardOverviewAction();
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    statisticsQuery,
    stakeSummaryQuery,
    financialSummaryQuery,
    recentValidatorQuery,
    unbondingRequestQuery,
    overviewQuery,
  };
}
